


export const formatRuleContentValues = (ruleContent) => {
    const parsedRuleContent = JSON.parse(ruleContent || "{}");
    const { commands } = parsedRuleContent;
    const formattedCommands = (commands || []).reduce((acc, { command }) => {
        const filteredQuery = {};
        const { query } = command;
        for (const [key, value] of Object.entries(query || {})) {
            if (value.trim().length > 0) {
                filteredQuery[key] = value.trim();
            }
        }
        acc.push({ command: { ...command, query: filteredQuery } });
        return acc;
    }, []);

    return JSON.stringify({ ...parsedRuleContent, commands: formattedCommands });
};